import { isTfvcType, isGitType } from "Search/Scenarios/Shared/Utils";
import { areFiltersEqual } from "Search/Scenarios/Shared/Utils";
import { CodeResult, SearchQuery } from "Search/Scenarios/WebApi/Code.Contracts";

export function getItemResultKey(item: CodeResult): string {
    if (!item) {
        return;
    }

    let identifier: string;
    if (isTfvcType(item.vcType)) {
        identifier = `${item.collection}/${item.project}/${item.repository}/${item.changeId}/${item.path}`;
    }
    else {
        identifier = `${item.collection}/${item.project}/${item.repository}/GB${item.branch}/${item.path}`;
    }

    return identifier;
}

export function areQueriesEqual(left: SearchQuery, right: SearchQuery): boolean {
    if (left.searchText !== right.searchText) {
        return false;
    }

    if (left.takeResults !== right.takeResults) {
        return false;
    }

    return areFiltersEqual(left.searchFilters, right.searchFilters);
}